<template>
  <div class="loan-search-wrap">
    <el-row>
      <el-form label-width="105px">
        <el-col :span="7">
          <el-form-item label="流水号">
            <el-input v-model="search.pipelineCode" placeholder="请输入流水号" maxlength="20" />
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="操作方向">
            <el-select class="rule" v-model="search.type" placeholder="请选择操作方向">
              <el-option label="冻结" value="0" />
              <el-option label="解冻" value="1" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="交易日期">
            <el-date-picker
              v-model="search.dealDate"
              @change="selectDate"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="—"
              start-placeholder="开始日期"
              end-placeholder="结束日期" />
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="业务单据号">
            <el-input v-model="search.businessCode" placeholder="请输入业务单据号" maxlength="20" />
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="源流水号">
            <el-input v-model="search.pipelineCodeRel" placeholder="请输入源流水号" maxlength="20" />
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <div class="search-button-wrap">
            <el-button type="primary" @click="query">查询</el-button>
            <el-button class="plain over" @click="reset">重置</el-button>
          </div>
        </el-col>
      </el-form>
    </el-row>
  </div>
</template>

<script>
function Search () {
  this.pipelineCode = '' // 流水号
  this.type = '' // 操作方向 0 冻结 1 解冻
  this.dealDate = [] // 交易时间数组
  this.startDealDate = '' // 交易时间 开始
  this.endDealDate = '' // 交易时间 结束
  this.pipelineCodeRel = '' // 源流水号
  this.businessCode = '' // 业务单据号
}
export default {
  name: 'LoanRecord',
  data () {
    return {
      search: new Search() // 搜索
    }
  },
  watch: {
    search: { // 信息项改变的时候，同步数据到父组件
      handler (val) {
        this.$emit('input', val)
      },
      deep: true
    }
  },
  methods: {
    // 选择日期,将头尾时间加上对应时间
    selectDate (val) {
      this.search.startDealDate = val[0] + ' 00:00:00'
      this.search.endDealDate = val[1] + ' 23:59:59'
    },
    // 查询
    query () {
      this.$nextTick(() => {
        this.$emit('query')
      })
    },
    // 重置
    reset () {
      this.search = new Search()
      this.$nextTick(() => {
        this.$emit('reset')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .loan-search-wrap{
    padding-top: 30px;
    .rule{
      width: 100%;
    }
    .search-button-wrap{
      margin-left: 38px;
      /deep/ .el-button{
        height: 36px;
        padding: 10px 20px;
      }
      .over{
        color: #666666;
        border: none !important;
      }
    }
  }
</style>
